import { URL_REPLACEMENT } from '$const';
import { get } from '~services/api/methods';

/**
 * Search content
 * @param string 'query' - the search value
 * @return Fetch response
 */
export const fetchSearchResult = async (query = '', pageOffset?: number) => {
  const params = new URLSearchParams();
  params.set('_format', 'api_json');
  params.set('keys', query);
  if (Boolean(pageOffset) && pageOffset > 0) {
    params.set('page[offset]', `${pageOffset}`);
  }

  const requestUrl = `${URL_REPLACEMENT.API_BASE}/search/?${decodeURIComponent(params.toString())}`;
  const response = await get<SearchDto>(requestUrl);
  // ToDo: add validation! see api/validators/*
  // return create(response, IJsonApiResponse);
  return response;
};
